import { useRef, useState } from "react";
import { ChevronsLeftRight } from "lucide-react";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const BeforeAfter = ({ job }) => {
    const ref = useRef(null);
    const [pos, setPos] = useState(50);
    const dragging = useRef(false);

    const update = (clientX) => {
        const rect = ref.current.getBoundingClientRect();
        const pct = ((clientX - rect.left) / rect.width) * 100;
        setPos(Math.min(96, Math.max(4, pct)));
    };
    const onDown = (e) => {
        dragging.current = true;
        ref.current.setPointerCapture?.(e.pointerId);
        update(e.clientX);
    };
    const onMove = (e) => dragging.current && update(e.clientX);
    const onUp = () => {
        dragging.current = false;
    };
    const onKey = (e) => {
        if (e.key === "ArrowLeft") setPos((p) => Math.max(4, p - 4));
        if (e.key === "ArrowRight") setPos((p) => Math.min(96, p + 4));
    };

    return (
        <div
            ref={ref}
            data-testid={`before-after-${job.id}`}
            className="relative aspect-[4/3] w-full overflow-hidden rounded-lg border border-brand-line select-none touch-none cursor-ew-resize bg-brand-elevated"
            onPointerDown={onDown}
            onPointerMove={onMove}
            onPointerUp={onUp}
            onPointerCancel={onUp}
            onPointerLeave={onUp}
        >
            <img
                src={`${API_BASE}${job.after_url}`}
                alt={`${job.title} — after stump grinding`}
                className="absolute inset-0 w-full h-full object-cover"
                draggable={false}
                loading="lazy"
            />
            <img
                src={`${API_BASE}${job.before_url}`}
                alt={`${job.title} — before stump grinding`}
                className="absolute inset-0 w-full h-full object-cover"
                style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
                draggable={false}
                loading="lazy"
            />

            <span className="absolute top-3 left-3 font-mono text-[10px] uppercase tracking-[0.2em] bg-brand-ink/80 backdrop-blur text-brand-cream px-2.5 py-1 rounded-full pointer-events-none">
                Before
            </span>
            <span className="absolute top-3 right-3 font-mono text-[10px] uppercase tracking-[0.2em] bg-brand-amber text-brand-ink px-2.5 py-1 rounded-full pointer-events-none">
                After
            </span>
            {job.sample && (
                <span
                    className="absolute bottom-3 left-3 font-mono text-[10px] uppercase tracking-[0.2em] bg-brand-ink/80 backdrop-blur text-brand-sage px-2.5 py-1 rounded-full pointer-events-none"
                    data-testid="gallery-sample-badge"
                >
                    Sample photo
                </span>
            )}

            <div className="absolute inset-y-0 w-0.5 bg-brand-cream pointer-events-none" style={{ left: `calc(${pos}% - 1px)` }} />
            <button
                type="button"
                aria-label="Drag to compare before and after"
                onKeyDown={onKey}
                data-testid="before-after-handle"
                className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-11 h-11 rounded-full bg-brand-cream text-brand-ink shadow-xl flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-brand-amber"
                style={{ left: `${pos}%` }}
            >
                <ChevronsLeftRight className="w-5 h-5" />
            </button>
        </div>
    );
};

export default BeforeAfter;
